<template>
    <div />
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            loginURL: process.env.VUE_APP_LOGIN_URL
        };
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        const lang = urlParams.get("lang") ?? "en-US";
        window.location.href = `${this.loginURL}${lang}`;
    }
};
</script>
